import React, { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as DetailsIcon } from '../../../images/Shared/Details.svg';
import { ReactComponent as ArrowIcon } from '../../../images/Shared/ArrowIcon.svg';
import styles from './BooksTable.module.css';
import CircularProgress from '@mui/material/CircularProgress';
import { showSuccessToast } from '../Toastify/toastHelper';
import { UserContext } from '../../../UserContext';
import { BooksDTO } from '../../../dto/BooksDTO';

interface TableColumn {
  title: string;
}

interface TableProps {
  columns: TableColumn[];
  data: any[];
  onEdit: (index: number) => void;
  onView: (index: number) => void;
  onDelete: (book:BooksDTO) => void;
  loading:boolean;
  onPreview:(url:string)=>void;
  onPublish:(book:BooksDTO)=>void;
  onArchive:(book:BooksDTO)=>void ;
  sortDirection: 'asc' | 'desc';
  handleSort: (column: string) => void;
  sortColumn: string | null;

}

const BooksTable: React.FC<TableProps> = ({ columns, data, onEdit, onView, onDelete,loading,onPreview,onPublish,onArchive,sortColumn,sortDirection,handleSort }) => {
  const {user}=useContext(UserContext)
  const [dropdownOpen, setDropdownOpen] = useState<number | null>(null);


  const selectedRowIndex = useRef<number | null>(null);
  const selectedFullText = useRef<string | undefined>(undefined);

  const dropdownRef=useRef<HTMLDivElement|null>(null)
  const toggleDropdown = (index: number) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
  };

  const handleRowClick = (rowIndex: number, fullText?: string) => {
    selectedRowIndex.current = rowIndex;
    selectedFullText.current = fullText;
  };

  //COPY TEXT
  useEffect(() => {
    const handleMouseUp = () => {
      const textSelected = window.getSelection()?.toString();
      if (textSelected && selectedFullText.current) {
        navigator.clipboard.writeText(selectedFullText.current).then(() => {
          showSuccessToast('Text copied to clipboard');
        });
      } else if (selectedRowIndex.current !== null) {
        onView(selectedRowIndex.current);
      }

      selectedRowIndex.current = null;
      selectedFullText.current = undefined;
    };

    document.addEventListener('mouseup', handleMouseUp);
    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [onView]);

  useEffect(()=>{
    const handleClickOutside=(event:MouseEvent)=>{
      if(dropdownRef.current && !dropdownRef.current.contains(event.target as Node)){
        setDropdownOpen(null)
      }
    }
    document.addEventListener("mousedown",handleClickOutside)
    return ()=>{
      document.addEventListener("mousedown",handleClickOutside)      
    }
},[])

  return (
    <div className={styles.container}>
      <div className={styles.table}>
        <div className={styles.tableHeader}>
          {columns.map((column, index) => (
            <div
              key={index}
              className={styles.tableHeaderCell}
              onMouseDown={() => handleSort(column.title)}
            >
              {column.title !== 'Cover' && column.title !== 'Logo' && (
                <ArrowIcon
                  className={`${styles.arrowIcon} ${sortColumn === column.title ? (sortDirection === 'asc' ? styles.asc : styles.desc) : ''}`}
                />
              )}
              {column.title}
            </div>
          ))}
        </div>
        <div className={styles.tableBody}>

          {!loading?
            data?.length?data.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <div className={styles.tableRow} onMouseDown={(event) =>{event.stopPropagation(); handleRowClick(rowIndex)}}>
                  {columns.map((column, colIndex) => (
                    <div key={colIndex} className={styles.tableCell} onMouseDown={(event) =>{event.stopPropagation(); handleRowClick(rowIndex,row[column.title])}}>
                      {['Cover', 'Logo'].includes(column.title) ? (
                        <img src={row[column.title]} alt={column.title} className={styles.coverImage} />
                      ):(
                        colIndex !== columns.length - 1 ?  
                          <p onMouseDown={(event) =>{event.stopPropagation(); handleRowClick(rowIndex,row[column.title])}} title={row[column.title] || 'null'} className={styles.spanStyle}>
                            {row[column.title]?row[column.title]:<i>null</i>}
                          </p>
                        :
                        <div className='flex items-center'> 
                          <span  onMouseDown={(event) =>{event.stopPropagation(); handleRowClick(rowIndex,row[column.title])}}>
                            {row.CreatedDate?row.CreatedDate:<i>null</i>}
                          </span>
                          <div className={styles.actions}>
                            <DetailsIcon  
                              className={styles.detailsIcon}
                              onMouseDown={(event) => { event.stopPropagation(); toggleDropdown(rowIndex); }}
                            />
                            {dropdownOpen === rowIndex && (
                              <div className={styles.dropdownMenu} ref={dropdownRef}>
                               {user?.role==='admin'?
                               <>
                                <div className={styles.dropdownItem} onMouseDown={(event) => {event.stopPropagation();onArchive(row);toggleDropdown(rowIndex)}}>{row.Archived===true?'Unarchive':'Archive'}</div>
                                <div className={styles.dropdownItem} onMouseDown={(event) => {event.stopPropagation();onPublish(row);toggleDropdown(rowIndex) }}>{row.Published===true?"Unpublish":"Publish"}</div>
                                </>
                                :<></>}
                                <div className={styles.dropdownItem} onMouseDown={(event) => {event.stopPropagation();onPreview(row._id);toggleDropdown(rowIndex)}}>Preview</div>
                                <div className={styles.dropdownItem} onMouseDown={(event) => {event.stopPropagation();onEdit(rowIndex);toggleDropdown(rowIndex)}}>Edit</div>
                                {user?.role==='admin'?<div className={styles.dropdownItem} onMouseDown={(event) => {event.stopPropagation();onDelete(row);toggleDropdown(rowIndex)}}>Delete</div>:<></>}
                              </div>
                            )}
                          </div>
                      </div>
                      )}
                    </div>
                  ))}
                  
                </div>
              
                <hr className={styles.rowSeparator} />
              </React.Fragment>
            )):
              <div className='text-center mt-5'>
                <h1>No data found</h1>
              </div>
          :
          <div className='text-center mt-5'>
              <CircularProgress/>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default BooksTable;
